import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextInputform } from "../../components/Forms";
import { VscEye, VscEyeClosed } from "react-icons/vsc";
import { generateStaffNoApi } from "../../services/StaffService";

const StaffCreation = ({ formData, setFormData, schema, editMode }) => {
  const [passwordVisibility, setPasswordVisibility] = useState({});

  const togglePasswordVisibility = (fieldName) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "staff_name" && value.length >= 1) {
      try {
        if (editMode) {
          const currentStaffNo = formData.staff_no || "";
          const sequenceNumber = currentStaffNo.slice(-3);
          let prefix = value.toLowerCase().slice(0, 4);
          prefix = prefix.replace(/[^a-z]/g, "");
          if (prefix.length < 4) {
            prefix = prefix.padEnd(4, "x");
          }
          const newStaffNo = prefix.toUpperCase() + sequenceNumber;
          setFormData((prev) => ({ ...prev, staff_no: newStaffNo }));
        } else {
          const staffNo = await generateStaffNoApi(value);
          setFormData((prev) => ({ ...prev, staff_no: staffNo }));
        }
      } catch (error) {
        console.error("Error generating staff_no:", error);
      }
    }
  };

  return (
    <div>
      <Container>
        <Row>
          {schema.map((field, index) => (
            <Col lg="12" md="12" xs="12" className="py-3" key={index}>
              <TextInputform
                textlabel={field.label}
                PlaceHolder={field.label}
                name={field.name}
                value={formData[field.name] || ""}
                formtype={
                  field.type === "password" && passwordVisibility[field.name]
                    ? "text"
                    : field.type
                }
                onChange={handleChange}
                classname={field.classname || ""}
                disabled={field.disabled || field.name === "staff_no"}
                suffix_icon={
                  field.type === "password" ? (
                    passwordVisibility[field.name] ? (
                      <VscEyeClosed
                        onClick={() => togglePasswordVisibility(field.name)}
                      />
                    ) : (
                      <VscEye
                        onClick={() => togglePasswordVisibility(field.name)}
                      />
                    )
                  ) : null
                }
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StaffCreation;
